import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
//
//component
import AppAuth from "./app_auth";
//redux
//selector
//actions

import {
  snapBaseAuth,
  unSnapBaseAuth,
} from "store/bailiff/auth/base_auth.action";

import { snapUserAuth, unSnapUserAuth } from "store/user/auth/user_auth.action";
//utils
//hook
//str
const AppRoot = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(snapUserAuth());
    return () => {
      dispatch(unSnapUserAuth());
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(snapBaseAuth());
    return () => {
      dispatch(unSnapBaseAuth());
    };
  }, [dispatch]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return <AppAuth />;
};
export default AppRoot;
